import { RouteConfig } from 'vue-router';
import {EditorRoute} from '@/modules/export/_modules/editor/routes/EditorRoute';

export const router: RouteConfig[] = [
  {
    path: `${EditorRoute.EDITOR_TEMPLATES.path}`,
    name: EditorRoute.EDITOR_TEMPLATES.name,
    component: () => import('/@/modules/export/_modules/editor/pages/EditorAdminDashboardPage.vue')
  }
];
